import BaseModel from '@spa/apps/trustup-pro-base-js/models/BaseModel';

export default class WorksiteFile extends BaseModel
{

    init(data = {})
    {
        super.init(data);

        if ( this.created_at ) {
            this.created_at = window.moment(data.created_at);
        }
    }

    static getPrefix()
    {
        return 'worksite:worksite-file';
    }

    static getEndpoint(worksite)
    {
        return window.Worksite.endpoints.worksiteFile.setWorksite(worksite);
    }

    getEndpoint()
    {
        return this.constructor.getEndpoint(this.currentCollection.worksite);
    }

    edit(data = {})
    {
        return super.edit({
            ...data,
            ...{
                worksite: this.currentCollection.worksite
            }
        });
    }

    getDownloadUrl()
    {
        return this.url;
    }

    data() {
        return {
            id: this.id,
            uuid: this.uuid,
            folder_id: this.folder_id,
            user_id: this.user_id,
            title: this.title,
            path: this.path
        }
    }

    isImage()
    {
        return this.meta.type == 'image/jpeg' || this.meta.type == 'image/png';
    }

    isPDF()
    {
        return this.meta.type == 'application/pdf';
    }

    getFAIconClass()
    {
        let className = 'text-2xl ';

        switch ( this.meta.type ) {
            case "application/pdf":
                className += 'fas fa-file-pdf text-red-600';
                break;

            case "application/msword":
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                className += 'fas fa-file-word text-blue-600';
                break;

            case "application/vnd.ms-excel":
            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                className += 'fas fa-file-excel text-green-600';
                break;

            case "text/csv":
                className += 'fas fa-file-csv text-green-600';
                break;

            case "text/plain":
                className += 'fas fa-file-alt text-gray-500';
                break;
            
            default: 
                className += 'fas fa-file text-gray-500';
        }

        return className;
    }

    getReadableSize(decimals = 2)
    {
        if (this.meta.size === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(this.meta.size) / Math.log(k));

        return parseFloat((this.meta.size / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    getType()
    {
        switch ( this.meta.type ) {
            case "application/pdf":
                return 'pdf';

            case "application/msword":
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                return 'word';

            case "application/vnd.ms-excel":
            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                return 'excel';

            case "text/csv":
                return 'csv';

            case "text/plain":
                return 'txt';
            
            default: 
                return this.meta.type.substring(this.meta.type.indexOf("/") + 1);
        }
    }

};